// extracted by mini-css-extract-plugin
export default {"play__button":"PlayButton_play__button__a4r5Z","play__button_paused":"PlayButton_play__button_paused__NrYGY"};